import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { NgForm } from '@angular/forms';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { ConfirmationPageSuccessComponent } from '../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { Router } from '@angular/router';
import { ClientRegister } from '../../../models/ClientRegister';
import { ViewChild } from '@angular/core';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { BusyIndicatorComponent } from '../../../shared-components/busy-indicator/busy-indicator.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-client-register',
  templateUrl: './client-register.component.html',
  styleUrls: ['./client-register.component.scss']
})
export class ClientRegisterComponent implements OnInit {
  public register: ClientRegister = new ClientRegister();
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;
  public successMsg: string;
  public errorMsg: string;
  public  emailmatchMsg: string;
  public validRecaptcha = false;
  public showRecaptchaError = false;
  public recaptchaKey = '6LfL_FoUAAAAAMaHg2_CEaHoDRZw1Nng0a3tGssO';//'6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
  public isComparePasswordMatched = true;
  public termsOfUse = '';
  public privacyPolicy = '';
  confirmEmail:boolean;
  passwordConfirm: Boolean;
  @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
  constructor(private accountSvc: AccountService,
  private router: Router,
  private spinner: NgxSpinnerService ) { }

  async ngOnInit() {
    // this.recaptchaKey = await this.accountSvc.getRecaptchaKey();
    // this.termsOfUse = await this.accountSvc.getHtmlFile('terms1');
    // this.privacyPolicy = await this.accountSvc.getHtmlFile('privacy1');
  }
  copyEmail() {
    if (this.register.universalFlag === true)   {
      this.register.UniversalEmail = this.register.Email;
    }

  }
  checkEmailExists() {
    this.emailmatchMsg = '';
    this.accountSvc.isEmailAlreadytExists(this.register.UniversalEmail).subscribe(
      data => {
                 if (data === true) {
                  this.successMsg = null;
                  this.emailmatchMsg = 'email address already exist';
                } else {
                  this.emailmatchMsg = '';
                }
            },
      err => {

          this.successMsg = null;
          this.errorMsg = err;

      }
    );
}


checkregisterUniversalEmailExists() {
  this.emailmatchMsg = '';
  this.confirmEmail = false;
  // this.dataService.userDisplayInfo.UniversalEmail = this.UniversalEmail;
  // this.LID  = this.dataService.userDisplayInfo.LID;
  // this.checkEmailExists();

    console.log('this.emailmatchmsg', this.emailmatchMsg);
  this.accountSvc.isRegisterUniversalEmailExists( this.register.UniversalEmail, '0')
  // .takeWhile(() => this.alive)
  .subscribe(
    data => {
                console.log('data userGuid', data);
                if (data.Myjssiexists === true) {

                   this.emailmatchMsg =  this.register.UniversalEmail +
                   ' is already associated with a JSSI Parts & Engines and/or a Conklin account. Please use a different email for your registration process to complete.';
                 } else if (data.exists === true) {
                   // this.nextbutton  = true;
                 //  this.emailmatchMsg = '';
                  this.confirmEmail = true;

               } else {
                // this.submitbutton = true;

                this.emailmatchMsg = '';
              }
          },
    err => {

        this.successMsg = null;
       // this.errorMsg = err;
       this.emailmatchMsg = '';

    }
  );

}

  onSubmit(frmClientReg: NgForm) {
    if (this.register.IsAgreement && this.validRecaptcha && !this.passwordConfirm) {
      frmClientReg.controls['register.IsAgreement'].setErrors(null);
      this.errorMsg = null;
      this.successMsg = null;
      this.spinner.show();
      this.register.Email = this.register.UniversalEmail;
      this.register.UserID  = this.register.UniversalEmail;
      this.accountSvc.clientRegister(this.register).subscribe(
        data => {
                  this.spinner.hide();
                  if (data.Result === true) {
                    this.showSuccessConfirmation = true;
                    this.showFailConfirmation = false;
                    this.successMsg = 'Thank you for registering with us.';
                    this.errorMsg = null;
                    this.register = new ClientRegister();
                    frmClientReg.reset();
                  } else {
                    this.showSuccessConfirmation = false;
                    this.showFailConfirmation = true;
                    this.successMsg = null;
                    this.errorMsg = 'Failed to register the user. Please contact Client Services at clientservices@jetsupport.com or 1-888-4My-JSSI or +1 312 494-8600 if outside the US.';
                  }
              },
        err => {
                  this.spinner.hide();
                  if (err._body.indexOf('Username or password is incorrect') > -1)   {
                    this.passwordConfirm = true;
                  } else {
                  this.showSuccessConfirmation = false;
                  this.showFailConfirmation = true;
                  this.successMsg = null;
                  this.errorMsg = err._body;
                  }

          }
      );
    } else {
      if (!this.register.IsAgreement) {
        frmClientReg.controls['register.IsAgreement'].setErrors({'incorrect' : true});
      } else {
        frmClientReg.controls['register.IsAgreement'].setErrors(null);
      }

      if (!this.validRecaptcha) {
        this.showRecaptchaError = true;
      } else {
        this.showRecaptchaError = false;
      }
    }
  }

  redirectTo(event) {
    this.router.navigate(['/pages/login']);
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.validRecaptcha = false;
    this.showRecaptchaError = false;
  }

  handleCorrectCaptcha(event) {
    console.log(event);
    this.validRecaptcha = true;
    this.showRecaptchaError = false;
  }

  handleCaptchaExpired() {
    console.log('expired');
    this.validRecaptcha = false;
    this.showRecaptchaError = false;
  }

  comparePasswords(frmClientReg: NgForm) {
    if (this.register.Password === this.register.ConfirmPassword) {
      frmClientReg.controls['register.ConfirmPassword'].setErrors(null);
      this.isComparePasswordMatched = true;
    } else {
      frmClientReg.controls['register.ConfirmPassword'].setErrors({'incorrect' : true});
      this.isComparePasswordMatched = false;
    }
  }

  checkpassword()  {
    this.passwordConfirm = false;

    this.accountSvc.checkPassword( this.register.UniversalEmail, this.register.Password)
  // .takeWhile(() => this.alive)
  .subscribe(
    data => {
                console.log(data);
              if (data.SucessMessage === 'success') {
               this.passwordConfirm = false;
              } else {
                this.passwordConfirm = true;
              }
          },
    err => {
            console.log(err);

    }
  );
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/account/client-register/client-register.component.ts